<div class="overLayDiv z-99999 active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel active w-60pc" style="z-index: 99999;">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{expenseCategoryName}}{{'view_expense_policy' | translate:param}}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnCloseExpensePolicyPanel()">
                    {{ 'label_close' | translate: param }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div class="block mt-2 padding-top-20 ">
                <div class="row">
                    <div class="col-lg-12 no-padding-right-left">
                        <ul class="bulkList pointer-events-none">
                            
                            <li class="d-flex border-bottom padding-bottom-12  f-14"
                                *ngFor="let policy of policyDetails">
                                <div class="fw-600" [ngClass]="policy.highlightedClass">
                                <span class="d-inline-block w-80pc">{{policy.policyName}}</span>
                                <span class="d-inline-block w-20pc text-right"
                                    *ngIf="policy.policyType==2 && policy.policyValue==1">ON</span>
                                <span class="d-inline-block w-20pc text-right"
                                    *ngIf="policy.policyType==2 && policy.policyValue==0">OFF</span>
                                <span class="d-inline-block w-20pc text-right"
                                    *ngIf="policy.policyType==1">{{policy.policyValue.toFixed(2)}} </span>
                                <span class="d-inline-block w-20pc text-right"
                                    *ngIf="policy.policyType==3">{{policy.policyValue}} {{'days' |
                                    translate:param}}</span>
                                </div>
                                <div class="mt-2" *ngIf="policy.notes.length>0">
                                    <h6 class="color-orange w-100pc mb-1">{{ 'policy_notes' | translate: param }}:</h6>
                                    <p class="f-13 lH-normal wordbreak" >{{policy.notes}}
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>